module.exports = __webpack_public_path__ + "static/media/icon-employer-contribution-white.d91b7641.svg";